import React, { useContext } from "react";
import { useInput } from "../../../hooks/input-hook";
import { navigate } from "gatsby";

import SiteMetaContext from "../../../contexts/SiteMetaContext";
import {
  theme3Vars,
  templateVariableValue,
} from "../../../helpers/templateVariables";
import { translateStatic } from "../../../helpers/translationHelper";
import * as theme3Styles from "../scss/theme3.module.scss";

import searchIcon from "../images/search-bold.png";

const Banner = () => {
  // eslint-disable-next-line no-unused-vars
  const { value: keyword, bind: bindKeyword, reset: resetKeyword } = useInput(
    ""
  );

  const siteData = useContext(SiteMetaContext);
  const {
    remarso: {
      domainByURL: {
        website: {
          setting: display_settings,
          templateConfiguration,
          template: { templateVariables },
        },
      },
    },
    currentLocaleKey: locale,
    defaultLocaleKey: defaultLocale,
  } = siteData;

  const handleSubmit = (evt) => {
    evt.preventDefault();
    navigate(`/${locale}/properties?search=${keyword}`);
  };

  const { display_search_bar } = display_settings;

  const homeTitle = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-main-title",
    locale,
    defaultLocale
  );
  const homeText = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-main-text",
    locale,
    defaultLocale
  );
  const backgroundImg = templateVariableValue(
    templateConfiguration,
    templateVariables,
    theme3Vars[0].slug,
    locale,
    defaultLocale
  );

  return (
    <section
      className={theme3Styles.banner}
      style={{
        backgroundImage: `url(${backgroundImg || theme3Vars[0].image})`,
      }}
      loading="lazy"
    >
      <div className={theme3Styles.wrapper}>
        <div className={theme3Styles.bannerTextC}>
          <div className={theme3Styles.bannerText}>
            <h2 className={theme3Styles.bannerTl}>{homeTitle}</h2>
            <form onSubmit={handleSubmit}>
              {(() => {
                if (display_search_bar) {
                  let placeholder = translateStatic(
                    "city",
                    locale,
                    defaultLocale
                  );
                  placeholder +=
                    ", " + translateStatic("address", locale, defaultLocale);
                  placeholder +=
                    ", " + translateStatic("zip_code", locale, defaultLocale);

                  return (
                    <div className={theme3Styles.banSearchBox}>
                      <input
                        type="text"
                        className={theme3Styles.searchField}
                        placeholder={placeholder}
                        {...bindKeyword}
                      />
                      <button className={theme3Styles.searchBtn}>
                        <img
                          alt={translateStatic("search", locale, defaultLocale)}
                          src={searchIcon}
                        />
                      </button>
                    </div>
                  );
                }
              })()}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
